

















































































import Vue from "vue";
import TableRow from "./TableRow.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import Search from "@/components/Search.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { onMounted, onBeforeUnmount, computed } from "@vue/composition-api";
import * as state from "./data/state";
import { UserAccount } from "./data/models";
import { tableConfig } from "./table.config";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { SortBy } from "@/common/models";
import { SharedState } from "@/common/state";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  components: {
    VirtualTable,
    Search,
    AppCheckbox,
  },
  setup() {
    const {
      isLoading,
      getAccounts,
      isSearching,
      query,
      displayAccounts,
      filters,
      loadMoreAccounts,
      totalAccountsCount,
      toggleAccountScanState,
      isPerformingAction,
      // check
      isCheckedAllAccounts,
      onAccountChecked,
      setIsCheckedAllAccounts,
      // scan
      scanAll,
      removeScanFromAll,
      // sort
      onSortingChanged,
      hasNoResults,
      noSearchResults,
    } = state;

    const subscriptions = {
      accounts: emptyFn(),
      checkChange: emptyFn(),
    };

    onMounted(() => {
      SharedState.onReady(() => {
        if (displayAccounts.value.length == 0) {
          getAccounts();
        }
      });

      subscriptions.accounts = EventBus.listen(
        "account-scan",
        (account: UserAccount) => {
          toggleAccountScanState(account);
        }
      );

      subscriptions.checkChange = EventBus.listen(
        "account-check-change",
        (account: UserAccount) => {
          onAccountChecked(account);
        }
      );
    });

    const checkedItemsCount = computed(() => {
      // @ts-ignore
      return displayAccounts.value.filter((item: UserAccount) => item.checked)
        .length;
    });

    onBeforeUnmount(() =>
      Object.values(subscriptions).forEach((unsub) => unsub())
    );

    const onTableSort = (sortBy: SortBy) => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Accounts_sort by " + sortBy.key,
      });
      // set the current active 'sort by' column.
      tableConfig.value = {
        columns: tableConfig.value.columns.map((col) => {
          if (col.key === sortBy.key) {
            col.sortDir = sortBy.dir;
            col.isSortActive = true;
          } else {
            col.isSortActive = false;
          }
          return col;
        }),
      };
      // reload the table from page 0 applying the sorting.
      onSortingChanged(sortBy);
    };

    const onShowSearch = () => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Accounts_search_click on search icon",
      });
    };

    return {
      TableRow,
      hasNoResults,
      isLoading,
      tableConfig,
      displayAccounts,
      totalAccountsCount,
      loadMoreAccounts,
      query,
      isSearching,
      noSearchResults,
      filters,
      isPerformingAction,
      isCheckedAllAccounts,
      setIsCheckedAllAccounts,
      checkedItemsCount,
      scanAll,
      removeScanFromAll,
      onTableSort,
      onShowSearch,
    };
  },
});
